export type AddressType = typeof AddressTypeEnum[keyof typeof AddressTypeEnum];

export const AddressTypeEnum = {
  BILLING: 'billing',
  SHIPPING: 'shipping'
} as const;
